<template>
  <div class="container">
        <div class="common-items-center common-space-between">
            <el-button size="small" type="primary" icon="el-icon-download" @click="serachBtn">导出</el-button>
        </div>
        <div class="warp-table">
        <el-table ref="giftTable" :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.tableSize"  row-key="id"  style="width: 100%"  :height="this.$store.state.windowHeight-260" lazy   @selection-change="checkSelectBtn">
            <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" type="selection"    width="55"></el-table-column>
            <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="date"         label="序号"    width="50">
              <template slot-scope="scope">{{scope.$index+1}}</template>
          </el-table-column>
            <el-table-column  align="left"   header-align="left"   :show-overflow-tooltip="true" prop="companyName"  label="企业名称" width="250" ></el-table-column>
            <el-table-column  align="left"   header-align="left"   :show-overflow-tooltip="true" prop="factoryName"  label="工厂名称" width="250"></el-table-column>
            <el-table-column  align="left"   header-align="left"   :show-overflow-tooltip="true" prop="name"         label="用户姓名" width="180"></el-table-column>
            <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="orderNo"      label="性别"     width="160">
            <template slot-scope="scope">
                <span v-if="scope.row.gender*1==1">男</span> 
                <span v-else>女</span>
            </template>  
            </el-table-column> 
            <el-table-column  align="left"   header-align="left"   :show-overflow-tooltip="true" prop="account"      label="用户账号" ></el-table-column>
            <el-table-column  align="left"   header-align="left"   :show-overflow-tooltip="true" prop="mobile"       label="手机号码" width="200"> </el-table-column>
            <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="createTime"    label="创建时间" width="180"> </el-table-column>
        </el-table>
        <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/> 
        </div> 
  </div>
</template>
<script>
import {scroll} from "@/components/component-mixin/block-scroll"
import {userApi} from '@/utils/config'
import {postFun,deleteFun,putFun} from '@/utils/httpFun'
export default {
  name: 'index',
  mixins: [scroll],
  components:{
    
  },
  data:()=>({  
    queueID:0,
    tableData: [{}],
    list: [
            { indexNo: '0', selectName: '禁用'}, 
            { indexNo: '1', selectName: '启用'}
          ],
    formData:{
      keyWord:"",
      status:""
    },
    current:1,
    size:10,
    total:10,   
  }),
  created(){
    this.size = this.$store.state.pageSize
    this.getDatas()
  },
  methods:{

    //获取所有的数据
    async getDatas(){
      let parms = {
          param:{
            userStatus:this.formData.status,
            keyWord: this.formData.keyWord
          },
          
          current:this.current,
          size:this.size
        }
        await postFun(userApi.USERUFACTORY,parms,res=>{
             this.tableData = res.data.records 
             this.total = res.data.total
             this.size = res.data.size
             this.current = res.data.current
        })
    },
    //获取输入框/选择框的值
    getVal(ev){
       if(ev.key=="keyWord"){
           this.formData.keyWord = ev.val
       }
       if(ev.key=="status"){
           this.formData.status = ev.indexNo
       }
    },
    
    //查询
    serachBtn(){
       this.getDatas()
    },
    
    //重置
    resetBtn(){
       this.formData.keyWord = ""
       this.formData.status = ""
       this.$refs.keyWord.setVal("")
       this.$refs.status.setVal("")
       this.current = 1
       this.getDatas()
    },
    
   //多选
    checkSelectBtn(ev){
       
    },

    //分页
    getPage(ev){
        this.size = ev.pageSize
        this.current = ev.pageNo 
        this.getDatas()
    }
  }
}
</script>
<style lang="scss" scoped>
    .container{
        padding:15px;
        box-sizing: border-box;
    }
    .warp-table{
        margin-top: 15px;
        width: 100%;
    }
</style>
